import { shouldAnimate } from '@/js/global/helpers'
import { register } from '@/js/global/shopify-theme-sections'
import { animateGridPromo } from '@/js/global/animations'


register("grid-promo", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateGridPromo = animateGridPromo(this.container);
    }
  },
  onUnload() {
    var _this$animateGridPromo;
    (_this$animateGridPromo = this.animateGridPromo) === null || _this$animateGridPromo === void 0 ? void 0 : _this$animateGridPromo.destroy();
  }
});
